// src/components/RelationsPanel.js
import React from 'react';

function yearOf(rfc) {
    const m = (rfc?.data?.date || '').match(/\d{4}/);
    return m ? m[0] : '';
}

function Section({ title, items, nodeById, onSelect }) {
    if (!items.length) return null;
    return (
        <div style={{ marginTop: 14 }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 6 }}>
                {title}
            </div>
            {items.map(id => {
                const n = nodeById.get(id);
                if (!n) return null;
                return (
                    <div
                        key={id}
                        onClick={() => onSelect(n)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={e => { if (e.key === 'Enter') onSelect(n); }}
                        style={{
                            cursor: 'pointer', padding: '6px 8px', marginBottom: 4,
                            borderRadius: 4, border: '1px solid #e3e3e3', background: '#fff'
                        }}
                    >
                        <div style={{ fontSize: 13, fontWeight: 600 }}>
                            {id} <span style={{ color: '#888', fontWeight: 400 }}>{yearOf(n)}</span>
                        </div>
                        <div style={{ fontSize: 11, color: '#666', lineHeight: 1.3 }}>
                            {n.data.title || ''}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default function RelationsPanel({ selected, allNodes, allEdges, onSelect, onBack, canGoBack }) {
    if (!selected?.data?.id) return null;
    const id = selected.data.id;

    const nodeById = new Map((allNodes || []).map(n => [n.data.id, n]));
    const pick = (type, dir) =>
        (allEdges || [])
            .filter(e => e?.data?.type === type && e.data[dir === 'in' ? 'target' : 'source'] === id)
            .map(e => e.data[dir === 'in' ? 'source' : 'target']);

    const replacedBy = pick('obsoletes', 'in');   // RFCs that obsolete this one (newer)
    const replaces = pick('obsoletes', 'out');     // RFCs this one obsoletes (older)
    const updatedBy = pick('updates', 'in');       // RFCs that update this one
    const updates = pick('updates', 'out');         // RFCs this one updates

    const isCurrent = replacedBy.length === 0;

    return (
        <div style={{
            width: 300, flexShrink: 0, borderLeft: '1px solid #ccc',
            background: '#fafafa', overflowY: 'auto'
        }}>
            {/* sticky header — stays visible while the relations scroll */}
            <div style={{
                position: 'sticky', top: 0, background: '#fafafa',
                padding: '14px 16px 10px', borderBottom: '1px solid #e3e3e3', zIndex: 1
            }}>
                <button
                    onClick={onBack}
                    disabled={!canGoBack}
                    style={{
                        marginBottom: 8, fontSize: 12, padding: '3px 10px', borderRadius: 4,
                        border: '1px solid #aaa', background: '#fff',
                        cursor: canGoBack ? 'pointer' : 'not-allowed',
                        opacity: canGoBack ? 1 : 0.4
                    }}
                >
                    ‹ Back
                </button>
                <div style={{ fontSize: 12, color: '#888' }}>{yearOf(selected)}</div>
                <div style={{ fontSize: 16, fontWeight: 600 }}>{id}</div>
                <div style={{ fontSize: 13, color: '#555', lineHeight: 1.35, marginTop: 2 }}>
                    {selected.data.title || ''}
                </div>
                <span style={{
                    display: 'inline-block', marginTop: 8, fontSize: 11,
                    padding: '2px 8px', borderRadius: 4,
                    background: isCurrent ? '#e1f5ee' : '#fbeae7',
                    color: isCurrent ? '#0F6E56' : '#993C1D'
                }}>
                    {isCurrent ? 'current' : 'obsoleted'}
                </span>
            </div>

            <div style={{ padding: '0 16px 16px' }}>
            <Section title="Replaced by" items={replacedBy} nodeById={nodeById} onSelect={onSelect} />
            <Section title="Replaces" items={replaces} nodeById={nodeById} onSelect={onSelect} />
            <Section title="Updated by" items={updatedBy} nodeById={nodeById} onSelect={onSelect} />
            <Section title="Updates" items={updates} nodeById={nodeById} onSelect={onSelect} />

            {!replacedBy.length && !replaces.length && !updatedBy.length && !updates.length && (
                <div style={{ marginTop: 16, fontSize: 12, color: '#999' }}>
                    No version relations — standalone RFC.
                </div>
            )}
            </div>
        </div>
    );
}
